export enum RMApiRequestEnum {
    getMetricLocalizations = "getMetricLocalizations",
    getUserSettings = "getUserSettings"
}


export type RMApiLoadingKey = keyof typeof RMApiRequestEnum;